import { Modal, Empty } from "antd";
import { Flex, Button, Text, Skeleton } from "@chakra-ui/react";
import InputSearch from "components/Input/InputSearch";
import CardPerson from "ui/components/Cards/CardPerson";
import colors from "core/resources/theme/colors";
import OutlineButton from "components/Button/OutlineButton";
import useConfirmarAutorizacaoPortariaLista from "core/features/portaria/hooks/useConfirmarAutorizacaoPortariaLista";
import Pagination from "components/Pagination/index";
import { useState } from "react";
import useListaConvidadosEvento from "core/features/portaria/hooks/useListaConvidadosEvento";

interface ModalPortariaPessoasProps {
  eventoId: string;
  portariaId: string;
  visible: boolean;
  onClose: () => any;
  showConfirmButton?: boolean;
}

export default function ModalPortariaPessoas({
  portariaId,
  eventoId,
  visible,
  onClose,
  showConfirmButton = true,
}: ModalPortariaPessoasProps) {
  const [cacheConfirmedIds, setCacheConfirmedIds] = useState<
    Record<string, boolean>
  >({});

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState<string | undefined>();
  const { data, isLoading, isFetching } = useListaConvidadosEvento(
    eventoId,
    {
      page,
      limit: 10,
      search,
    },
    visible
  );

  const { mutate: confirmar, isLoading: isLoadingConfirmar } =
    useConfirmarAutorizacaoPortariaLista();

  const _isLoading = isLoading || isFetching;

  return (
    <Modal
      width={"600px"}
      title="Pessoas"
      footer={
        <Flex flex={1} justify="end">
          <OutlineButton onClick={onClose}>Fechar</OutlineButton>
        </Flex>
      }
      visible={visible}
      onCancel={onClose}
    >
      <Flex flexDir="column" mb={10}>
        <Flex mb={6}>
          <InputSearch
            defaultValue={search || ""}
            onSearch={(v) => setSearch(v)}
            maxW="100%"
          />
        </Flex>

        {_isLoading ? (
          <>
            <Skeleton h="64px" w="100%" mb={2} />
            <Skeleton h="64px" w="100%" mb={2} />
            <Skeleton h="64px" w="100%" />
          </>
        ) : null}

        {!_isLoading && !data?.items.length ? (
          <Empty description="Ainda não foram adicionados convidados a este evento." />
        ) : null}

        {!_isLoading && data?.items.length
          ? data?.items?.map((item, index) => {
              const isConfirmed =
                item.lastLogDate || !!cacheConfirmedIds[item.id!];

              return (
                <Flex
                  key={item.id}
                  justify="space-between"
                  align="center"
                  borderTop={index === 0 ? "" : `solid 1px ${colors.gray}`}
                  py={2}
                >
                  <CardPerson
                    avatarUrl={item.imagemUrl ? item.imagemUrl : ""}
                    nome={item.nome ? item.nome : "--"}
                    isPeriod={false}
                  />

                  {isConfirmed ? <Text> Já entrou.</Text> : null}

                  {!isConfirmed && showConfirmButton ? (
                    <Button
                      onClick={() =>
                        confirmar(
                          { id: portariaId!, eventoPessoaId: item.id },
                          {
                            onSuccess: () => {
                              setCacheConfirmedIds((state) => ({
                                ...state,
                                [item.id!]: true,
                              }));
                            },
                            onError: () => {
                              setCacheConfirmedIds((state) => ({
                                ...state,
                                [item.id!]: false,
                              }));
                            },
                          }
                        )
                      }
                      size="sm"
                      isLoading={isLoadingConfirmar}
                      shadow="lg"
                      colorScheme="green"
                      type="button"
                    >
                      Confirmar chegada
                    </Button>
                  ) : null}
                </Flex>
              );
            })
          : null}
      </Flex>
      <Pagination
        style={{ marginLeft: "auto", marginBottom: 16 }}
        current={data?.meta?.currentPage ?? 1}
        total={data?.meta?.totalItems ?? 0}
        pageSize={data?.meta?.itemsPerPage ?? 0}
        onChange={(page) => {
          setPage(page);
        }}
      />
    </Modal>
  );
}
